






import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GSideMenuHeader',
  props: {
    text: { type: String as PropType<string>, required: true },
    isBottomLineRequired: { type: Boolean as PropType<boolean>, default: true, required: false },
  },
});
